import { useEffect, useState } from 'react';
import ArrowTopIcon from './Icon/arrow-circle-top-svgrepo-com.svg'; // Rename if needed

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
   
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return  (
    <button
      onClick={scrollToTop}
      style={{
        position: 'fixed',
        bottom: '2rem',
        right: '2rem',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        zIndex: 999,
      }}
      aria-label="Back to Top"
    >
      <img
        src={ArrowTopIcon}
        alt="Back to top"
        style={{
          width: '50px',
          height: '50px',
          filter: 'drop-shadow(0 0 5px rgba(0,0,0,0.3))',
        }}
      />
    </button>
  ) 
//   : null;
};

export default BackToTop;
